import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';

const ItemsPerPage = ({clang, ipp, setIpp, activeIpp}) => {
    return (
        <div className="ipp">
            <ul className="ipp__list">
                {ipp.map(item => <li className="ipp__item" key={item.val}>
                                    <button className={`ipp__button ${item.val === activeIpp ? 'active' : ''}`}
                                            onClick={() => setIpp(item.val)}>
                                        {item.val}
                                    </button>
                                 </li>)}
             </ul>
             <p className="ipp__text">
                {lang[clang].ipp.results_number}
             </p>
        </div>
    );
};

ItemsPerPage.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(ItemsPerPage);



// WEBPACK FOOTER //
// ./src/components/items-per-page/ItemsPerPage.js